
import { Box, Button } from "@mui/material";
import { CheckCircleOutline, Replay } from "@mui/icons-material";

export const ToggleResolvedButton = ({ conversation, toggleResolved }) => {
  const isResolved = !!conversation.resolved;

  return (
    <Box>
      <Button
        color={!isResolved ? "success" : "error"}
        variant={"ghost"}
        size="small"
        onClick={toggleResolved}
        sx={{
          px: 2,
          borderRadius: 3,
          textTransform: "none",
        }}
        startIcon={isResolved ? <Replay fontSize="small" /> : <CheckCircleOutline fontSize="small" />}
      >
        {isResolved ? "Mark as Unresolved" : "Mark as Resolved"}
      </Button>
    </Box>
  );
}
